export default {
  LOAD_LIST_MOEDA(state, data) {
    state.listMoedas = data
  },
  PREPARE_TO_EDIT_MOEDA(state, data) {
    state.moeda = data
  },
  RESET_MOEDA(state) {
    state.moeda = {
      nome: '',
      descricao: '',
      ativo: true,
    }
  },
}
